import React from 'react';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { Link } from 'react-router-dom';
import '../../styles/login-register/login-register.scss';
import Grid from '@material-ui/core/Grid';
import HeaderAuth from '../includes/HeaderAuth';

//Milan Andrejic
import axios from 'Axios';
import { Redirect } from 'react-router';
import styled from 'styled-components';

const InputNotification = styled.span`
  text-align: right;
  text-decoration: none;
  color: red;
  font-size: 0.875rem;
  display: inline-block;
  padding: 0.5rem 0;
`;

class ForgotPassword extends React.Component {
  state = {
    email: '',
    error: '',
    redirectToNextStep: false,
    disableButton: false,
  };
  //
  // UNSAFE_componentWillReceiveProps(nextProps) {
  //     if (nextProps.location.pathname != this.props.location.pathname) {
  //         this.setState({
  //             password: '',
  //             email: ''
  //         });
  //     }
  // }

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  resetPassForEmail = () => {
    this.setState({
      disableButton: true,
    });
    if (this.state.email !== '') {
      if (this.state.error === '') {
        axios
          .post('account/reset_password', {
            email: this.state.email,
          })
          .then(res => {
            this.setState({
              email: '',
              redirectToNextStep: true,
              disableButton: true,
            });
          })
          .catch(error => {
            this.setState({ error: error.response.data.message });
          });
      } else {
        this.setState({
          error: 'Email must be in valid format: someone@test.com',
        });
      }
    } else {
      this.setState({
        error: 'Fill email field',
      });
    }
  };

  handleBlurValidateEmail = () => event => {
    if (
      event.target.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) !== null
    ) {
      this.setState({ error: '' });
    } else {
      this.setState({
        error: 'Email must be in valid format: someone@test.com',
      });
    }
  };

  render() {
    if (this.state.redirectToNextStep) {
      return (
        <Redirect
          to={{
            pathname: '/email-sent',
            state: { finishMessage: 'bravo' },
          }}
        />
      );
    }
    return (
      <Grid spacing={0} container>
        <Grid
          className={'forgot-password-background b-entry-background'}
          item
          xs={12}
        >
          <HeaderAuth type="/login" />
          <Grid
            className="center-vertically forgot-pass-wrapper"
            container
            alignItems={'center'}
            justify={'center'}
          >
            <Grid
              item
              xs={11}
              sm={5}
              lg={3}
              className="b-entry-credentials-wrapper"
            >
              <div className="b-entry-credentials-wrapper__text">
                <h3 className="b-entry-credentials-wrapper__text t-primary-24 t-color-w u-mrg-bot-20">
                  Forgot your password?
                </h3>
                <span className="b-entry-credentials-wrapper__text t-secondary-16 t-color-w">
                  No problem! Enter your email and we'll send you a link to
                  reset your password.
                </span>
              </div>
              <FormControl fullWidth className="u-mrg-top-20">
                <InputLabel
                  htmlFor="Email"
                  classes={{
                    // underline: 't-color-w',
                    root: 't-color-w',
                  }}
                >
                  Email
                </InputLabel>
                <Input
                  classes={{
                    underline: 'underline--c-white',
                    root: 't-color-w',
                  }}
                  id="email"
                  type="text"
                  label="Email"
                  value={this.state.email}
                  onChange={this.handleChange('email')}
                  onBlur={this.handleBlurValidateEmail()}
                />
                <InputNotification>{this.state.error}</InputNotification>
              </FormControl>

              <Button
                disabled={this.state.disableButton}
                variant="contained"
                color="primary"
                fullWidth
                className="u-mrg-top-30 t-weight-b"
                onClick={this.resetPassForEmail}
              >
                Request reset link
              </Button>

              <p className="t-secondary-16 t-align-c u-mrg-top-30">
                <Link to="/login" className="link-bellow-button t-color-w">
                  Back to Login
                </Link>
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default ForgotPassword;
